// Right-sized images from CDNs that resize on the fly. Only images.unsplash.com
// (the placeholder catalogue photos) is rewritten: w (px), q and auto=format
// (WebP/AVIF where the browser supports it). Every other URL (our own R2
// uploads, Pexels, data: URLs) is returned unchanged.

const RESIZABLE_HOSTS = new Set(['images.unsplash.com']);

export const sizedImage = (src, width, quality = 70) => {
  if (!src || typeof src !== 'string') return src;
  let url;
  try { url = new URL(src); } catch { return src; }
  if (url.protocol !== 'https:' || !RESIZABLE_HOSTS.has(url.hostname)) return src;
  url.searchParams.set('w', String(Math.round(width)));
  url.searchParams.set('q', String(quality));
  url.searchParams.set('auto', 'format');
  return url.toString();
};

/** srcSet for a resizable URL (undefined otherwise, so the attribute is omitted). */
export const sizedSrcSet = (src, widths = [400, 600, 800], quality = 70) => {
  if (sizedImage(src, widths[0], quality) === src) return undefined;
  return widths.map((w) => `${sizedImage(src, w, quality)} ${w}w`).join(', ');
};

// Phones with ~3× screens get a ~2× image: the `sizes` slot shrinks to two
// thirds there, so the browser picks a candidate about half the bytes. On a
// photo this size the difference is not visible; the layout is unchanged
// (sizes only chooses the file). Browsers without `resolution` media queries
// ignore the condition and use the full slot.
export const HIGH_DPR = '(min-resolution: 2.5dppx)';

/** `sizes` entries for a `vw` slot, capped near 2× on high-density screens. */
export const dprCappedSizes = (vw) => `${HIGH_DPR} ${Math.round((vw * 2) / 3)}vw, ${vw}vw`;
